import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { AuthCallbackComponent } from './auth-callback/auth-callback.component';
import { AuthGuard } from './core/guards/auth.guard';
import { DocumentationComponent } from './pages/dashboard/documentation/documentation.component';
import { KibanaDashboardComponent } from './pages/dashboard/kibana-dashboard/kibana-dashboard.component';
import { GetPlanResolver } from './core/resolvers/get-plan.resolver';

export const routes: Routes = [
  { path: 'auth-callback', component: AuthCallbackComponent },
  {
    path: 'proforma-invoices/:id',
    canActivate: [AuthGuard],
    loadComponent: () =>
      import(
        './pages/financial/proforma-invoice-view/proforma-invoice-view.component'
      ).then((m) => m.ProformaInvoiceViewComponent),
  },
  {
    path: '',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./layout/layout.module').then((m) => m.LayoutModule),
  },
  {
    path: 'account',
    loadChildren: () =>
      import('./pages/account/account.module').then((m) => m.AccountModule),
  },
  {
    path: 'landing-page',
    loadChildren: () =>
      import('./pages/landing-page/landing-pages.module').then(
        (m) => m.LandingPagesModule,
      ),
  },

  {
    path: 'kibana',
    component: KibanaDashboardComponent,
  },
  {
    path: 'documentation',
    canActivate: [AuthGuard],
    component: DocumentationComponent,
    children: [{ path: '**', component: DocumentationComponent }],
  },
  // {
  //   path: 'plan/:planId',
  //   resolve: { planInfo: GetPlanResolver },
  //   loadComponent: () =>
  //     import('./pages/buy-plan/buy-plan.component').then(
  //       (m) => m.BuyPlanComponent,
  //     ),
  // },
  {
    path: 'form/:id',
    loadChildren: () =>
      import('./pages/form-builder/form-builder.module').then(
        (m) => m.FormModule,
      ),
  },
  {
    path: 'online-survey/:id',
    loadComponent: () =>
      import('./pages/online-surveys/online-survey/online-survey.component').then(
        (m) => m.OnlineSurveyComponent,
      ),
  },
  // {
  //   path: ':pageName/:param',
  //   canActivate: [AuthGuard],
  //   loadChildren: () =>
  //     import('./layout/layout.module').then((m) => m.LayoutModule),
  // },
  {
    path: ':pageName',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./layout/layout.module').then((m) => m.LayoutModule),
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
